// Run accessibility fixes immediately when script executes to preempt Swym overrides
(function() {
  const updateLabel = (target) => {
    const productTitle = target.getAttribute('data-product-title');
    if (productTitle) {
      const currentLabel = target.getAttribute('aria-label');
      if (currentLabel && !currentLabel.includes(productTitle)) {
        let newLabel = currentLabel;
        if (currentLabel.toLowerCase().includes('add')) {
          newLabel = `Add ${productTitle} to Wishlist`;
        } else if (currentLabel.toLowerCase().includes('remove') || currentLabel.toLowerCase().includes('added') || currentLabel.toLowerCase().includes('in')) {
          newLabel = `Remove ${productTitle} from Wishlist`;
        } else {
          newLabel = `${currentLabel} - ${productTitle}`;
        }
        target.setAttribute('aria-label', newLabel);
      }
    }
  };

  // Run initial passes over all existing buttons in the DOM
  const initializeLabels = () => {
    document.querySelectorAll('.swym-button, [data-swaction="addToWishlist"]').forEach(updateLabel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLabels);
  } else {
    initializeLabels();
  }
  window.addEventListener('load', initializeLabels);

  // Setup MutationObserver to watch for dynamic updates
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
        const target = mutation.target;
        if (target.classList.contains('swym-button') || target.getAttribute('data-swaction') === 'addToWishlist') {
          // Temporarily disconnect observer to prevent an infinite loop
          observer.disconnect();
          updateLabel(target);
          // Resume observing
          observer.observe(document.body, {
            attributes: true,
            subtree: true,
            attributeFilter: ['aria-label']
          });
        }
      }
    });
  });

  // Start observing body mutations immediately
  if (document.body) {
    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-label']
    });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-label']
      });
    });
  }
})();

window.addEventListener("load", function() {
  function onSwymLoadCallback(swat) {
    let event = 'sw:addedtowishlist';

    let addedToWishlist = async function(e) {
      var data = e.detail.d;

      const trackingItemData = {
        item_name: data.dt,
        item_id: data.sku,
        quantity: 1,
        price: data.pr,
        currency: 'USD',
        affiliation: data.bt,
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_wishlist",
        ecommerce: {
          currency: 'USD',
          value: data.pr,
          items: [
            {
              ...trackingItemData
            },
          ]
        }
      });
    };
      window._swat.evtLayer.addEventListener(event, addedToWishlist);
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
});